import { render, staticRenderFns } from "./indicator.vue?vue&type=template&id=49aab7ec&scoped=true&"
import script from "./indicator.vue?vue&type=script&lang=ts&"
export * from "./indicator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49aab7ec",
  null
  
)

export default component.exports